import Snackbar from '@mui/material/Snackbar';
import Fade from '@mui/material/Fade';

import StackedToast from './StackedToast';

const AUTO_HIDE_MS = 10000;

/**
 * Single global host for page notifications: top-center, Fade, StackedToast.
 * Rendered once inside PageNotificationProvider (dashboard layout).
 */
export default function PageNotificationHost({ notification, onClose }) {
  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={AUTO_HIDE_MS}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      slots={{ transition: Fade }}
      slotProps={{ transition: { timeout: 280 } }}
      sx={(theme) => ({
        top: { xs: 72, sm: 80 },
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)',
        maxWidth: 'min(100%, calc(100vw - 32px))',
        zIndex: theme.zIndex.snackbar
      })}
    >
      <StackedToast
        severity={notification.severity}
        title={notification.title}
        message={notification.message}
        onClose={onClose}
      />
    </Snackbar>
  );
}
